/* services/settlements.service.ts */
import { http } from './http.service';

export interface Settlement {
    id: number;
    name: string;
}

export const SettlementsService = {
    async getSettlements(): Promise<Settlement[]> {
        const response = await http.get<Settlement[] | { data: Settlement[] }>('/Settlements');
        if (Array.isArray(response)) {
            return response;
        }
        return response?.data || [];
    }
};
